//@flow

import * as React from 'react';

import { Customer } from './domain/customer';
import { impossible } from './domain/utils';
import ChildCustomer1 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_c01@3x.png';
import ChildCustomer2 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_c02@3x.png';
import ChildCustomer3 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_c03@3x.png';
import ManCustomer1 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_m01@3x.png';
import ManCustomer2 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_m02@3x.png';
import ManCustomer3 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_m03@3x.png';
import WomanCustomer1 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_f01@3x.png';
import WomanCustomer2 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_f02@3x.png';
import WomanCustomer3 from '../../../../assets/images/pages/pizza/fields/pizza_kyaku_f03@3x.png';

type Props = {
  customer: Customer,
  position: 'center' | 'left' | 'right',
  children?: React.Node,
  talking: boolean,
  className?: string,
};

const customerImage = (customer: Customer) => {
  switch (customer.type) {
    case 'child':
      switch (customer.subtype) {
        case 1:
          return ChildCustomer1;
        case 2:
          return ChildCustomer2;
        case 3:
          return ChildCustomer3;
        default:
          return '';
      }
    case 'man':
      switch (customer.subtype) {
        case 1:
          return ManCustomer1;
        case 2:
          return ManCustomer2;
        case 3:
          return ManCustomer3;
        default:
          return '';
      }
    case 'woman':
      switch (customer.subtype) {
        case 1:
          return WomanCustomer1;
        case 2:
          return WomanCustomer2;
        case 3:
          return WomanCustomer3;
        default:
          return '';
      }
    default:
      return impossible(customer.type);
  }
};

class PizzaCustomer extends React.PureComponent<Props> {
  render() {
    const { customer, children, position, talking, className, ...rest } = this.props;
    const classes = ['pizza-image', 'pizza-customer', `pizza-customer--${position}`];
    if (className) classes.push(className);
    if (talking) classes.push('pizza-customer--talking');

    return (
      <div {...rest} className={classes.join(' ')}>
        {children}
        <img className="pizza-customer-img" src={customerImage(customer)} />
      </div>
    );
  }
}

export default PizzaCustomer;
